import {Menu} from "../Header/menu";
import React, {Component} from 'react';
import {Link} from "react-router-dom";
import { Footer } from '../Body/footer';

class Savatcha extends Component {

    constructor(props) {
        super(props);
        this.state = {
            counter: 0
        }
    }

    decNumber = () => {
        if (this.state.counter < 1){
            this.setState(
                {counter: this.state.counter = 0}
            )
        } else {
            this.setState(
                {
                    counter: this.state.counter - 1
                }
            )
        }
    }

    incNumber = () => {
        this.setState({counter: this.state.counter + 1});
    }

    calculateTotalPrice = () => {
        let totalPrice = document.getElementById('')
    }

    render() {
        return (
            <div>
                <div className="savatcha">
                    <Menu/>
                    <div className="container savatcha-header mb-5">
                        <div className="savatcha-header__routesLink mt-2">
                            <span className="savatcha-header__Link mr-2">
                                <Link to={"/"} className="savatcha-header__HomePageLink">Главная</Link>
                            </span>
                                <span className="mr-2">
                                <i className="fa fa-angle-right" color="#9d9d9d"></i>
                            </span>
                                <span className="disabled savatcha-header__Link">
                                <Link to="/savat" className="savatcha-header__SavatchaLink">Корзина</Link>
                            </span>
                        </div>
                        <h1 className="mt-1">Корзина</h1>
                        <div className="row mt-5">
                            <div className="col-8 ml-3 p-0">
                                <div className="row pt-3 savatcha-header__ProductInfo bg-white">
                                    <div className="col-3 offset-1 text-center">
                                        <p className="savatcha-header__ProductInfo__p">Товар</p>
                                    </div>
                                    <div className="col-2 text-center">
                                        <p className="savatcha-header__ProductInfo__p">Цена</p>
                                    </div>
                                    <div className="col-2 text-center">
                                        <p className="savatcha-header__ProductInfo__p">Кол-во</p>
                                    </div>
                                    <div className="col-2 text-center">
                                        <p className="savatcha-header__ProductInfo__p">	Итого</p>
                                    </div>
                                </div>
                                <div className="mt-4 savatcha-header_div__BuyProduct">
                                    <div className="savatcha-header__ProductBrand py-2 pl-2">
                                    <span className="savatcha-header_span__ProductBrand">
                                        <img
                                            src="https://lh3.googleusercontent.com/proxy/oPxECx2ZNtRu6g0dL-Me7ij0-3xcOp8a6IfKcahD3NJXj09dKNmYJLEvIEPc-jlA9TpHuqmJmg2mwN_RDKs"
                                            alt=""/>
                                    </span>
                                        <span className="pl-3">
                                        Asaxiy Book
                                    </span>
                                    </div>
                                    <div
                                        className="row py-3 savatcha-header__ProductInfo savatcha-header__block__BuyProduct bg-white">
                                        <div className="col-4 text-center">
                                            <div className="row">
                                                <div className="col-6 my-auto savatcha-header_img__ProductImg">
                                                    <img
                                                        src="https://wp.toko.uz/wp-content/uploads/2021/01/5e15bf0f44a91.jpg"
                                                        alt=""/>
                                                </div>
                                                <div className="col-6">
                                                    <p className="text-left mb-0">Vavillionning eng KETMON odami kitobi.
                                                        KETMON kitobni sotib oling!</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-2 text-center my-auto pr-0">
                                            <p className="savatcha-header__block__CostProduct">16 000 so'm</p>
                                        </div>
                                        <div className="col-2 my-auto text-center">
                                            <div className="input-group w-75 mx-auto">
                                                <button className="btn savatcha-header__block__CostProductNumber pl-2">
                                                    <i className="fa fa-minus" onClick={this.decNumber}></i>
                                                </button>
                                                <button className="btn savatcha-header__block__CostProductNumber">
                                                    <i className="fa fa-plus" onClick={this.incNumber}></i>
                                                </button>
                                                <input type="tel" className="form-control text-center px-4" value={this.state.counter}/>
                                            </div>
                                        </div>
                                        <div className="col-2 text-center my-auto pr-0">
                                            <p className="savatcha-header__block__CostProduct" id={"price__per"}>16 000 so'm</p>
                                        </div>
                                    </div>
                                    <div className="savatcha-header__ProductFooter row">
                                        <div className="col-6 py-2">
                                            <p>Доставка</p>
                                        </div>
                                        <div className="col-6 py-2">
                                            <p>10 000 so'm</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-3 p-0">
                                <div className="savatcha-header__SecondProductInfo">
                                    <p className="savatcha-header__SecondProductInfo_p">Итого</p>
                                    <div className="row savatcha-header__SecondProductInfo_row">
                                        <div className="col-4">
                                            <p className="savatcha-header__SecondProductInfo_row_col4_p1 mb-2">Подытог</p>
                                        </div>
                                        <div className="col-8 text-right">
                                            <p className="savatcha-header__SecondProductInfo_row_col8_p1 mb-2">16 000 so'm</p>
                                        </div>
                                    </div>
                                    <div className="row savatcha-header__SecondProductInfo_row">
                                        <div className="col-4">
                                            <p className="savatcha-header__SecondProductInfo_row_col4_p2 mb-2">Доставка</p>
                                        </div>
                                        <div className="col-8 text-right">
                                            <p className="savatcha-header__SecondProductInfo_row_col8_p2 mb-2">10 000 so'm</p>
                                        </div>
                                    </div>
                                    <div className="row savatcha-header__SecondProductInfo_row">
                                        <div className="col-4">
                                            <p className="savatcha-header__SecondProductInfo_row_col4_p3">Итого</p>
                                        </div>
                                        <div className="col-8 text-right">
                                            <p className="mt-2 savatcha-header__SecondProductInfo_row_col8_p3">26 000 so'm</p>
                                        </div>
                                    </div>
                                    <button className="btn w-100 savatcha-header__SecondProductInfo_row_button">
                                        Оформить заказ
                                    </button>
                                </div>
                            </div>
                        </div>
                        <button className="mt-5 px-4 py-2 border-0 savatcha-header_footer_button">Продолжить покупки</button>
                    </div>
                    <Footer/>
                </div>
            </div>
        )
    }
}

export default Savatcha;